// Add to cart feedback (Theme settings > LizenzPRO style > Add to cart feedback), loaded only when it is on.
// Listens to Shopify's cart lines event that Horizon fires for every add to cart:
// - "button": the clicked button turns navy and shows "✓ Added" for a moment
// - "drawer": the added line lights up in the cart drawer that opens afterwards
(() => {
  const script = document.currentScript;
  const mode = script?.dataset.mode;
  const addedLabel = script?.dataset.added || 'Added';
  if (!mode || mode === 'none') return;

  const BUTTONS = '[ref="addToCartButton"], button[name="add"], .lz-pdp__add, .lz-card__add, .lz-sugg__add';

  const confirmButton = (source) => {
    const button = source?.matches?.(BUTTONS) ? source : source?.querySelector?.(BUTTONS);
    if (!button) return;
    // Narrow buttons (product cards) only get the check mark
    button.dataset.lzAddedLabel = button.offsetWidth < 140 ? '✓' : `✓ ${addedLabel}`;
    button.removeAttribute('data-lz-added');
    void button.offsetWidth;
    button.setAttribute('data-lz-added', 'true');
    clearTimeout(button.lzAddedTimer);
    button.lzAddedTimer = setTimeout(() => button.removeAttribute('data-lz-added'), 1800);
  };

  const highlightRows = (keys) => {
    let tries = 0;
    // The drawer re-renders after the add, so look for the rows until they exist (max. about 3 s)
    const find = () => {
      const rows = keys.flatMap((key) => [...document.querySelectorAll(`.cart-items__table-row[data-key="${CSS.escape(key)}"]`)]);
      if (!rows.length && ++tries < 30) return setTimeout(find, 100);
      for (const row of rows) {
        row.classList.remove('lz-just-added');
        void row.offsetWidth;
        row.classList.add('lz-just-added');
        setTimeout(() => row.classList.remove('lz-just-added'), 2200);
      }
    };
    setTimeout(find, 150);
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !event.promise) return;
    const variantIds = (event.lines || []).map((line) => String(line.merchandiseId || '').split('/').pop());
    const source = event.target;
    Promise.resolve(event.promise).then((result) => {
      if (!result?.cart || result.userErrors?.length) return;
      if (mode === 'button') confirmButton(source);
      if (mode === 'drawer') {
        const keys = (result.cart.lines || [])
          .map((line) => String(line.id))
          .filter((id) => variantIds.some((v) => id.startsWith(`${v}:`)));
        highlightRows(keys);
      }
    }).catch(() => {});
  });
})();
